import { extend } from 'vee-validate';

extend('jp_postal_code', {
  validate: (value) => {
    if (value) {
      // https://en.wikipedia.org/wiki/Postal_codes_in_Japan
      return /^\d{7}$|^\d{3}-\d{4}$/.test(value);
    } else {
      return true;
    }
  },
});

extend('jp_postal_code_invalid', {
  validate: () => {
    return false;
  },
});
